<template>
  <v-dialog v-model="show" :max-width="450" :fullscreen="$vuetify.breakpoint.xsOnly" transition="dialog-bottom-transition" scrollable>
    <v-card :class="{ 'rounded-xl': !$vuetify.breakpoint.xsOnly }" elevation="10" class="d-flex flex-column text-center">
      <v-card-title class="pa-4 primary white--text d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-bold">Suspender usuario</span>
        <v-btn icon dark @click="closeModal" v-if="$vuetify.breakpoint.xsOnly">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-8 pb-4 text-center">
        <v-icon size="64" color="warning" class="mb-4">mdi-alert-circle-outline</v-icon>
        <div class="text-h6 font-weight-regular grey--text text--darken-2">
          ¿Quieres suspender al usuario <br/> <strong class="black--text">{{ userSelected.name }} {{ userSelected.lastName }}</strong>?
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4 d-flex justify-center bg-white">
        <v-btn
          color="grey"
          text
          @click="closeModal"
          :disabled="isLoading"
          class="px-4 mx-2"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="error"
          rounded
          @click="suspend"
          :loading="isLoading"
          elevation="0"
          class="px-8 mx-2"
        >
          Suspender
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data: () => ({
    isLoading: false,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("user", ["userSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("user", ["suspendUser"]),
    ...mapMutations("user", ["SET_USER_TO_UPDATE"]),
    closeModal() {
      this.SET_USER_TO_UPDATE(null);
      this.show = false;
    },
    async suspend() {
      try {
        let payload = {
          userId: this.userSelected._id,
        };
        let response = await this.suspendUser(payload);
        if (!response) throw response;
        this.$emit("fetchData");
        this.SET_USER_TO_UPDATE(null);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Usuario actualizado",
          timeout: 5000,
        });
        this.show = false;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al suspender usuario",
          timeout: 5000,
        });
      }
    },
  },
};
</script>
